export default "__VITE_ASSET__VyMlvIFa__"